export default "__VITE_ASSET__BCIbdcUm__"